import { action, makeObservable, observable } from 'mobx';
import { TCVSSreens, ECVSStatus, TCVSReportSreens } from '../../../global/types/types';
import { getCompanyId } from '../../../global/helpers/actions';
import settings from '../../../global/config/settings';

class CvsStore {
  cvsTabScreen: TCVSSreens = 'list';
  cvsReportTabScreen: TCVSReportSreens = 'list';
  cvsStatus?: ECVSStatus;
  cvsReportStatus?: ECVSStatus;

  isOpenSuboordinateEntitiesTableModal: boolean = false;
  entityIds: string[] = [];

  setCVSTabScreen(screen: TCVSSreens) {
    this.cvsTabScreen = screen;
  }

  setCVSStatus(eaStatus: ECVSStatus) {
    this.cvsStatus = eaStatus;
  }

  setCVSReportTabScreen(screen: TCVSReportSreens) {
    this.cvsReportTabScreen = screen;
  }

  setReportCVSStatus(eaStatus: ECVSStatus) {
    this.cvsReportStatus = eaStatus;
  }

  openSuboordinateEntitiesTableModal() {
    this.isOpenSuboordinateEntitiesTableModal = true;
  }

  closeSuboordinateEntitiesTableModal() {
    this.isOpenSuboordinateEntitiesTableModal = false;
  }

  setEntityIds(ids: string[]) {
    const isFO = settings.MODULE.toLowerCase() === 'fo';

    if (isFO && !ids.includes(getCompanyId()!)) {
      ids.push(getCompanyId()!);
    }

    this.entityIds = ids;
  }

  constructor() {
    makeObservable(this, {
      cvsTabScreen: observable,
      cvsReportTabScreen: observable,
      cvsStatus: observable,
      isOpenSuboordinateEntitiesTableModal: observable,
      entityIds: observable,
      setCVSTabScreen: action,
      setCVSStatus: action,
      setReportCVSStatus: action,
      openSuboordinateEntitiesTableModal: action,
      closeSuboordinateEntitiesTableModal: action,
      setEntityIds: action
    });
  }
}

const singleton = new CvsStore();
export default singleton;
